import { z } from 'zod';
import {
  isLegalAge,
  isValidCpf,
  validateDateString,
  validatePhone,
  validateZipCode
} from '../../utils/validate';

export type UserSchema = z.infer<typeof userSchema>;

export const userSchema = z.object({
  nome: z
    .string({
      required_error: 'Campo obrigatório',
      invalid_type_error: 'Campo obrigatório'
    })
    .regex(/^[a-zA-Z\s]+$/, { message: 'Para este campo, utilize apenas letras :)' }),
  email: z.string().email({ message: 'Email precisa ser válido' }),
  cpf: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .nullable()
    .refine(arg => isValidCpf(arg), {
      message: 'CPF precisa ser válido'
    }),
  dataNascimento: z
    .string()
    .nullable()
    .refine(arg => validateDateString(arg), { message: 'Digite uma data válida' })
    .refine(arg => isLegalAge(arg), { message: 'É preciso ter 18 anos para publicar um anúncio' }),
  celular: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .nullable()
    .refine(arg => arg && arg.length > 0, { message: 'Campo obrigatório' })
    .refine(arg => validatePhone(arg), { message: 'Digite um número válido' }),
  telefone: z
    .string()
    .nullable()
    .refine(arg => validatePhone(arg), { message: 'Digite um número válido' }),
  cep: z
    .string()
    .nullable()
    .refine(arg => arg && arg.length > 0, { message: 'Campo obrigatório' })
    .refine(arg => validateZipCode(arg), { message: 'Digite um número válido' }),
  endereco: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .min(4, {
      message: 'Digite um endereço válido'
    })
    .nullable(),
  bairro: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .nullable(),
  cidadeNome: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .nullable(),
  cidadeId: z.number().nullable(),
  ufNome: z
    .string({
      required_error: 'Campo obrigatório'
    })
    .nullable(),
  ufId: z.string().nullable(),
  mostrarTelefone: z.boolean().nullable(),
  optins: z.array(
    z.object({
      id: z.number(),
      nome: z.string(),
      descricao: z.string(),
      status: z.boolean()
    })
  )
});
